import { Search, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useMerchantCategories } from "@/hooks/useMerchantCategories";
import type { Deal } from "@/lib/types/deals";

interface SearchBarWithCategoryProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  selectedCategory: string;
  onCategoryChange: (value: string) => void;
  deals?: Deal[];
}

export function SearchBarWithCategory({
  searchQuery,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  deals = [],
}: SearchBarWithCategoryProps) {
  const { categories, loading } = useMerchantCategories({ deals });

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="flex flex-col sm:flex-row gap-3">
        {/* Search Input */}
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
          <Input
            type="text"
            placeholder="Search gift cards (Amazon, Apple, Uber…)"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="h-14 pl-12 pr-4 text-lg rounded-xl border-2 border-border bg-card shadow-sm focus-visible:ring-accent focus-visible:border-accent"
          />
        </div>

        {/* Category Dropdown - Only shows categories with deals */}
        <Select
          value={selectedCategory}
          onValueChange={onCategoryChange}
        >
          <SelectTrigger className="h-14 w-full sm:w-[200px] rounded-xl border-2 border-border bg-card shadow-sm text-base">
            {loading ? (
              <div className="flex items-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" />
                <span>Loading...</span>
              </div>
            ) : (
              <SelectValue placeholder="All Categories" />
            )}
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="All">All Categories</SelectItem>
            {categories.map((cat) => (
              <SelectItem key={cat.category} value={cat.category}>
                {cat.category} ({cat.count})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
